<template>
  <div class="form">
    <form>
      <h1>Profil</h1>
      <label for>Login</label>
      <br>
      <input placeholder="Login do profilu Instagram..." required type="text">
      <br>
      <label for>Hasło</label>
      <br>
      <input placeholder="Hasło do profilu Instagram..." required type="password">
      <br>
    </form>
    <button @click.prevent="loginToProfile()">Zaloguj</button>
  </div>
</template>

<script>
export default {
  name: 'LoginToProfileModal'
};
</script>

<style>

</style>
